import React from 'react';

const Button = props => {
  return <div>Form Button</div>;
};

export default Button;
